class FaqAccordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelector(".faq-accordion__title").addEventListener(
      "click",
      this.openAccordion.bind(this)
    );
  }

  openAccordion() {
    const allAccordions = document.querySelectorAll("faq-accordion");

    // Close all other accordions
    allAccordions.forEach((accordion) => {
      if (accordion !== this) {
        accordion.classList.remove("active");
        const panel = accordion.querySelector(
          ".faq-accordion__title"
        ).nextElementSibling;
        panel.style.maxHeight = null;
      }
    });

    // Toggle the clicked accordion
    this.classList.toggle("active");
    const panel = this.querySelector(
      ".faq-accordion__title"
    ).nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  }
}

customElements.define("faq-accordion", FaqAccordion);
